const ApiAttributesKeys = {
  notesIdKey: 'id',
  notesNameKey: 'name',
  notesReadingIdKey: 'reading_id',
  descriptionKey: 'discription',
  notesStatsKey: 'frm_notes_stat.answer_status',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/View/ApiAttributesKays.js